import { useQuery } from '@tanstack/react-query';
import {
  getOnboardingStatus,
  type OnboardingStatusResponse,
} from '@/lib/api/onboardingStatus';
import { queryKeys } from '@/queries/keys';

export function useOnboardingStatus(
  organizationId: string | undefined,
  options?: { enabled?: boolean }
) {
  return useQuery<OnboardingStatusResponse>({
    queryKey: organizationId
      ? queryKeys.onboardingStatus.byOrg(organizationId)
      : queryKeys.onboardingStatus.all(),
    queryFn: async () => {
      if (!organizationId) throw new Error('Organization ID required');
      return getOnboardingStatus(organizationId);
    },
    enabled: !!organizationId && (options?.enabled ?? true),
    staleTime: 30 * 1000,
  });
}
